
/**
 *  8/10/2019 v 1.0 - JuanMa
 *
 * v1.1  14/10/2019 En extraerDatosPieEstilos, si el resultado es un array vacío, devolvemos null.
 * v1.2  15/10/2019 En extraerDatosPieEstilos, si el tipo es cHora, usar como valor el campo descriptivo.
 * v1.3  04/11/2019 Añadido el tratamiendo del tipo CELLTIPO_FECHA_IZQUIERDA:
 * v1.4  05/11/2019 Añadido el filtrado de columnas que no tienen pdfHide.
 * v1.5  06/11/2019 Añadido coloreador a las columnas en el método extraerColumnasTitulosEstilos,
 * v1.6  08/11/2019 Añadida función extraerDatosParaExcel
 * v.2.0 30/09/2020 Cambiado a framework2
 * v.2.1 25/01/2021 El valor calculado en CELLTIPO_FLOTANTE, CELLTIPO_ENTERO, cuando es null se devuleve "".
 * v.2.2 24/07/2024 Añadido en el metodo extraerDatosParaExcel, el else para esForeignJPA(campo)
 **/

import {esForeign, esForeignJPA, getValorDeForeign, getValorDeForeignJPA} from "../../ej2/utils/ForeignUtils";
import {
    CELLTIPO_CADENA, CELLTIPO_CANTIDAD,
    CELLTIPO_CHORA, CELLTIPO_ENTERO,
    CELLTIPO_FECHA, CELLTIPO_FECHA_IZQUIERDA,
    CELLTIPO_FECHAHORA, CELLTIPO_FLOTANTE, CELLTIPO_HORA, CELLTIPO_LISTA,
    CELLTIPO_MONEDA, CELLTIPO_PORCENTAJE, CELLTIPO_SINO
} from "../../ej2/UI/TiposCeldas";
import {
    getFormattedDateFromTimestamp,
    getFormattedDateTimeFromTimestamp,
    getFormattedTimeFromTimestamp
} from "../../ej2/utils/DateUtils";
import {getValorPropiedad} from "../utils/ObjectUtils";


export const generarColumnStyles= (columnas) => {
    let columnStyles= {};
    columnas.forEach( (columna, index) => {
        if (!columna.pdfHide) {
            let columnaStyle = {};
            switch (columna.tipo) {
                case CELLTIPO_CADENA:
                case CELLTIPO_LISTA:
                    columnaStyle.halign = 'left';
                    break;
                case CELLTIPO_FECHA:
                case CELLTIPO_FECHAHORA:
                case CELLTIPO_FECHA_IZQUIERDA:
                case CELLTIPO_CHORA:
                case CELLTIPO_SINO:
                case CELLTIPO_HORA:
                case CELLTIPO_LISTA:
                //case CELLTIPO_BOOLEANO:
                    columnaStyle.halign = 'center';
                    break;
                case CELLTIPO_CANTIDAD:
                case CELLTIPO_MONEDA:
                case CELLTIPO_PORCENTAJE:
                case CELLTIPO_ENTERO:
                case CELLTIPO_FLOTANTE:
                    columnaStyle.halign = 'right';
                    break;
                default:
                    break;
            }
            columnaStyle.cellWidth = columna.ancho;
            if (columna.tipo == CELLTIPO_HORA){
                console.log("cellWidth: ", columna.ancho);
                columnaStyle.cellWidth += 25;
            }
            columnStyles[index] = columnaStyle;
        }
    });
    return columnStyles;
}

export const extraerColumnasTitulosEstilos= (columnas) => {
    if (!columnas)
        return [];
    let columnasFormateadas = columnas.reduce((columnasReduced, columna) => {
        if (!columna.pdfHide) {
            let newColumna = {content: columna.titulo};
            switch (columna.tipo.toUpperCase()) {
                case 'CELLTIPO_CADENA':
                case 'CELLTIPO_LISTA':
                    newColumna.styles = {halign: 'left'};
                    break;
                case CELLTIPO_FECHA:
                case CELLTIPO_FECHA_IZQUIERDA:
                case CELLTIPO_FECHAHORA:
                case CELLTIPO_CHORA:
                case CELLTIPO_HORA:
                case CELLTIPO_SINO:
                case CELLTIPO_LISTA:
                //case CELLTIPO_BOOLEANO:
                    newColumna.styles = {halign: 'center'};
                    break;
                case CELLTIPO_CANTIDAD:
                case CELLTIPO_MONEDA:
                case CELLTIPO_PORCENTAJE:
                case CELLTIPO_ENTERO:
                case CELLTIPO_FLOTANTE:
                    newColumna.styles = {halign: 'right'};
                    break;
                default:
                    break;
            }
            if (columna.coloreador)
                newColumna.coloreador= columna.coloreador;
            columnasReduced.push(newColumna);
        }
        return columnasReduced;
    }, []);
    return columnasFormateadas;
}

export const formatearDatos= (datos, columnas) => {
    if (!datos)
        return [];

    console.log(">>>> formatearDatos <<<<");


    let datosFormateados = datos.reduce((rowsReduced, row) => {
        let newRow= {};
        let esPie= typeof row.esPie === 'boolean' && row.esPie === true;
        if (!esPie) {
            columnas.forEach((columna) => {
                if (!columna.pdfHide) {
                    let campo = columna.campo;
                    let tipo = columna.tipo;
                    let valor = row[columna.campo];

                    if (esForeign(campo)) {
                        valor = getValorDeForeign(campo, row);
                    } else {
                        switch (tipo) {
                            case CELLTIPO_CADENA:
                                break;
                            case CELLTIPO_FECHA:
                            case CELLTIPO_FECHA_IZQUIERDA:
                                valor = getFormattedDateFromTimestamp(valor);
                                break;
                            case CELLTIPO_FECHAHORA:
                                valor = getFormattedDateTimeFromTimestamp(valor);
                                break;
                            case CELLTIPO_CHORA:
                                valor = valor.horaMinutosDescriptivo;
                                break;
                            case CELLTIPO_MONEDA:
                            case CELLTIPO_PORCENTAJE:
                            case CELLTIPO_CANTIDAD:
                                valor = valor ? valor.toString() : "";
                                break;
                            case CELLTIPO_ENTERO:
                                valor = valor ? valor.toString() : "";
                                break;
                            case CELLTIPO_FLOTANTE:
                                valor = valor ? valor.toString(): "";
                                break;
                            case CELLTIPO_SINO:
                            case CELLTIPO_LISTA:
                                break;
                            default:
                                break;
                        }
                    }
                    newRow[campo] = valor;
                }
            });
            rowsReduced.push(newRow);
        }
        return rowsReduced;
    }, []);

    return datosFormateados;
}

export const extraerDatosValores= (datos, columnas) => {
    if (!datos)
        return [];

    let datosFormateados = datos.reduce((rowsReduced, row) => {
        let newRow= [];
        let esPie= typeof row.esPie === 'boolean' && row.esPie === true;
        if (!esPie) {
            columnas.forEach((columna) => {
                if (!columna.pdfHide) {
                    let campo = columna.campo;
                    let tipo = columna.tipo;
                    let valor = row[columna.campo];

                    /*
                    console.log("columna: ");
                    console.log("campo: ", campo);
                    console.log("tipo: ", tipo);
                    console.log("esForeign(campo): ", esForeign(campo));
                    */

                    if (esForeign(campo) ) {
                        valor = getValorDeForeign(campo, row);
                    } else {
                        if (esForeignJPA(campo)) {
                            valor = getValorPropiedad(row, campo);
                        }
                        else {
                            switch (tipo) {
                                case CELLTIPO_CADENA:
                                    break;
                                case CELLTIPO_FECHA:
                                case CELLTIPO_FECHA_IZQUIERDA:
                                    valor = getFormattedDateFromTimestamp(valor);
                                    break;
                                case CELLTIPO_FECHAHORA:
                                    valor = getFormattedDateTimeFromTimestamp(valor);
                                    break;
                                case CELLTIPO_CHORA:
                                    valor = valor.horaMinutosDescriptivo;
                                    break;
                                case CELLTIPO_MONEDA:
                                case CELLTIPO_PORCENTAJE:
                                case CELLTIPO_CANTIDAD:
                                    valor = valor ? valor.toString() : "";
                                    break;
                                case CELLTIPO_ENTERO:
                                    valor = valor ? valor.toString() : "";
                                    break;
                                case CELLTIPO_FLOTANTE:
                                    valor = valor ? valor.toString() : "";
                                    break;
                                case CELLTIPO_SINO:
                                case CELLTIPO_LISTA:
                                    console.log("CELLTIPO_LISTA");
                                    console.log("campo: ", campo);
                                    console.log("columna: ", columna);
                                    valor= columna.valores[valor].nombre;
                                    console.log("valor: ", valor);

                                    break;
                                case CELLTIPO_HORA:
                                    valor = getFormattedTimeFromTimestamp(valor);
                                    break;
                                default:
                                    break;
                            }
                        }
                    }
                    newRow.push(valor);
                }
            });
            rowsReduced.push(newRow);
        }
        return rowsReduced;
    }, []);
    return datosFormateados;
}

export const extraerDatosValoresPie= (datos, columnas) => {
    if (!datos)
        return [];

    let newRowPie= [];
    datos.forEach((row) => {
        let esPie= typeof row.esPie === 'boolean' && row.esPie === true;
        if (esPie) {
            columnas.forEach( (columna) => {
                if (!columna.pdfHide) {
                    let valor = "";
                    valor = row[columna.campo];
                    if (!valor)
                        valor = "";
                    newRowPie.push(valor);
                }
            });
        }
    });
    return newRowPie;
}


export const extraerDatosValoresPieEstilos= (datos, columnas) => {
    if (!datos)
        return [];

    /*
    console.log("extraerDatosValoresPieEstilos");
    console.log(datos);
    console.log(columnas);
    */

    let newRowPie= [];
    datos.forEach((row) => {
        let esPie= typeof row.esPie === 'boolean' && row.esPie === true;
        if (esPie) {
            columnas.forEach( (columna) => {
                if (!columna.pdfHide) {
                    let valor = "";
                    valor = row[columna.campo];
                    if (!valor)
                        valor = "";

                    let newColumna = {content: valor};
                    switch (columna.tipo.toUpperCase()) {
                        case 'CELLTIPO_CADENA':
                        case 'CELLTIPO_LISTA':
                            newColumna.styles = {halign: 'left'};
                            break;
                        case 'CELLTIPO_FECHA':
                        case 'CELLTIPO_FECHA_IZQUIERDA':
                        case 'CELLTIPO_FECHAHORA':
                        case 'CELLTIPO_SINO':
                        case 'CELLTIPO_BOOLEANO':
                            newColumna.styles = {halign: 'center'};
                            break;
                        case 'CELLTIPO_CANTIDAD':
                        case 'CELLTIPO_MONEDA':
                        case 'CELLTIPO_PORCENTAJE':
                        case 'CELLTIPO_ENTERO':
                        case 'CELLTIPO_FLOTANTE':
                            newColumna.styles = {halign: 'right'};
                            break;
                        case 'CELLTIPO_CHORA':
                            newColumna.content = valor.horaMinutosDescriptivo;
                            newColumna.styles = {halign: 'center'};
                            break;
                        default:
                            break;
                    }
                    newRowPie.push(newColumna);
                }
            });
        }
    });
    //console.log("newRowPie");
    //console.log(newRowPie);
    if (newRowPie.length == 0)
        newRowPie= null;
    return newRowPie;
}

export const extraerPieDeDatos= (datos, columnas) => {

    if (!datos)
        return {};

    let pie= {};
    datos.forEach((row) => {
        if(typeof row.esPie === 'boolean' && row.esPie === true) {
            columnas.forEach((columna) => {
                if (!columna.pdfHide) {
                    let campo = columna.campo;
                    let tipo = columna.tipo;
                    let valor = row[columna.campo];
                    if (valor) {
                        switch (tipo) {
                            case CELLTIPO_CADENA:
                                break;
                            case CELLTIPO_FECHA:
                            case CELLTIPO_FECHA_IZQUIERDA:
                                valor = getFormattedDateFromTimestamp(valor);
                                break;
                            case CELLTIPO_FECHAHORA:
                                valor = getFormattedDateTimeFromTimestamp(valor);
                                break;
                            case CELLTIPO_CHORA:
                                valor = valor.horaMinutosDescriptivo;
                                break;
                            case CELLTIPO_MONEDA:
                            case CELLTIPO_PORCENTAJE:
                            case CELLTIPO_CANTIDAD:
                                valor = valor.toString();
                                break;
                            case CELLTIPO_ENTERO:
                                valor = valor.toString();
                                break;
                            case CELLTIPO_FLOTANTE:
                                valor = valor.toString();
                                break;
                            case CELLTIPO_SINO:
                            case CELLTIPO_LISTA:
                                break;
                            default:
                                break;
                        }
                    }
                    pie[campo] = valor;
                }
            });
        }

    });

    return pie;

}


export const extraerDatosParaExcel= (datos, columnas) => {
    if (!datos)
        return [];

    let datosFormateados = [];
    datos.forEach( (dato) => {
        let newDato = {};
        let esPie = typeof dato.esPie === 'boolean' && dato.esPie === true;
        columnas.forEach((columna) => {
            if (!columna.excelHide) {
                let campo = columna.campo;
                let tipo = columna.tipo;
                let valor = dato[columna.campo];
                let titulo = columna.titulo;
                if (esForeign(campo)) {
                    valor = getValorDeForeign(campo, dato);
                }
                else {
                    if (esForeignJPA(campo)) {
                        valor = getValorDeForeignJPA(campo, dato);
                        console.log("valor: ", valor);
                    }
                    else {
                        switch (tipo) {
                            case CELLTIPO_CADENA:
                                break;
                            case CELLTIPO_FECHA:
                            case CELLTIPO_FECHA_IZQUIERDA:
                                valor = getFormattedDateFromTimestamp(valor);
                                break;
                            case CELLTIPO_FECHAHORA:
                                valor = getFormattedDateTimeFromTimestamp(valor);
                                break;
                            case CELLTIPO_CHORA:
                                valor = valor.horaMinutosDescriptivo;
                                break;
                            case CELLTIPO_MONEDA:
                            case CELLTIPO_PORCENTAJE:
                            case CELLTIPO_CANTIDAD:
                                valor = valor.toString();
                                break;
                            case CELLTIPO_ENTERO:
                                valor = valor.toString();
                                break;
                            case CELLTIPO_FLOTANTE:
                                valor = valor.toString();
                                break;
                            case CELLTIPO_SINO:
                            case CELLTIPO_LISTA:
                                break;
                            default:
                                break;
                        }
                    }
                }
                newDato[titulo]= valor;
            }
        });

        datosFormateados.push(newDato);
    });
    return datosFormateados;
}
